// extracted by mini-css-extract-plugin
export default {"iframe":"_2iDMLtXWzR-NZda6MYf1V_","info":"_1vSNB3pYMdvbXkdGaY1gCm"};